import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './TeamData.scss'

class TeamData extends Component {
    render() {
        const { teamLevel } = this.props;
        return (
            <div className="teamItem">
                {this.props.teamList.map((item,index) => {
                    return <div key={index} className='team-item' onClick={() => (teamLevel === 1 || teamLevel === 2) && this.props.groupClickFuc(item.accountId)}>
                        <div className='team-title'>
                            <p className='team-title-name'>{item.name}</p>
                            <span className='team-title-tag'>{item.teamAccountType}</span>
                        </div>
                        <div className='team-content'>
                            <div className='team-content-part'>
                                <p className='team-content-title'>总注册客户</p>
                                <p className='team-content-vale'>{item.registerAllCount}</p>
                            </div>
                            <div className='team-content-part'>
                                <p className='team-content-title'>总获额客户</p>
                                <p className='team-content-vale'>{item.quotaAllCount}</p>
                            </div>
                            <div className='team-content-part'>
                                <p className='team-content-title'>总首提客户</p>
                                <p className='team-content-vale'>{item.withdrawFirstCount}</p>
                            </div>
                            <div className='team-content-part'>
                                <p className='team-content-title'>总首提金额</p>
                                <p className='team-content-vale'>{item.withdrawFirstAmount}</p>
                            </div>
                        </div>
                    </div>
                })}
            </div>
        )
    }
}

TeamData.propTypes = {
    teamList: PropTypes.array.isRequired,
    groupClickFuc: PropTypes.func,
    teamLevel: PropTypes.number
}
export default TeamData;
